import { formatDateServer } from './formatDate'

export const TODAY = formatDateServer(new Date())

export const currentDay = formatDateServer(new Date())
